document.addEventListener('DOMContentLoaded', () => {
  const localStorage = window.localStorage
  const checkbox = document.querySelector('.js-dark-mode__trigger')

  if (!checkbox) return

  if (localStorage.getItem('dark-mode')) {
    checkbox.checked = true
    document.documentElement.setAttribute("theme", "dark");
  } else {
    checkbox.checked = false
    document.documentElement.setAttribute("theme", "light");
  }

  checkbox.addEventListener('click', () => {
    if (checkbox.checked) {
      localStorage.setItem('dark-mode', 'on')
      document.documentElement.setAttribute("theme", "dark");
    } else {
      localStorage.removeItem('dark-mode')
      document.documentElement.setAttribute("theme", "light");
    }
  })
})
